import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";
import CloseOutlined from "@mui/icons-material/CloseOutlined";

import {
  CircularProgress,
  Dialog,
  IconButton,
  Rating,
  TextField,
} from "@mui/material";

import "./CustomerRating.css";
import "../Components/Components.css";
import Loader from "../Components/Loader";
import { getFormCSAT, updateFormCSAT } from "../Store/Actions/TicketAction";

const CustomerRating = ({ formID, onClose }) => {
  const [hover, setHover] = useState(-1);
  const [isLoading, setIsLoading] = useState(true);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [rating, setRating] = useState(0);
  const [review, setReview] = useState("");
  const [ticketID, setTicketID] = useState(null);
  const [searchParams] = useSearchParams();

  const labels = {
    1: "Terrible",
    2: "Poor",
    3: "Fair",
    4: "Great",
    5: "Excellent",
  };

  useEffect(() => {
    getFormCSAT(formID ?? searchParams.get("id"))
      .then((response) => {
        if (response.status) {
          console.log("form data", response.data);
          setIsSubmitted(response.data.issubmitted);
          setRating(response.data.rating ?? 0);
          setReview(response.data.description ?? "");
          setTicketID(response.data.ticketid);
          setIsLoading(false);
        } else {
          console.log("error", response.error);
          setIsLoading(false);
          toast.error("Error getting form data", { autoClose: 5000 });
        }
      })
      .catch((err) => {
        console.log("err", err);
        setIsLoading(false);
        toast.error("Error getting form data", { autoClose: 5000 });
      });
  }, []);

  function getLabelText(value) {
    return `${value} Star${value !== 1 ? "s" : ""}, ${labels[value]}`;
  }

  return (
    <div className="customer-rating landingContainerOrigin">
      <div className="landingChat">
        <Dialog
          open
          className="dialog customer-rating-dialog"
          fullWidth
          maxWidth="md"
          scroll="paper"
        >
          <div className="dialog-container">
            <form
              method="post"
              onSubmit={(event) => {
                event.preventDefault();
                setIsSubmitting(true);

                updateFormCSAT({
                  ticketformcsatguid: searchParams.get("id"),
                  ticketid: ticketID,
                  rating: rating,
                  description: review,
                })
                  .then((response) => {
                    if (response.status) {
                      toast.success("Rating submitted!", {
                        autoClose: 5000,
                      });

                      setIsSubmitting(false);
                      setIsSubmitted(true);
                    } else {
                      console.log("error", response.error);

                      toast.error("Error submitting rating", {
                        autoClose: 5000,
                      });

                      setIsSubmitting(false);
                    }
                  })
                  .catch((err) => {
                    console.log("err", err);
                    toast.error("Error submitting rating", { autoClose: 5000 });
                    setIsSubmitting(false);
                  });
              }}
            >
              <div className="dialog-content">
                <h2 className="title">Customer Rating</h2>

                {isLoading ? (
                  <Loader />
                ) : (
                  <div className="text-fields">
                    {isSubmitted && !formID && (
                      <p className="submitted">Thank you for your feedback!</p>
                    )}

                    <div className="rating">
                      <p>Rating</p>

                      <div className="stars">
                        <Rating
                          readOnly={isSubmitted || formID}
                          size="large"
                          value={rating}
                          getLabelText={getLabelText}
                          onChange={(event, newValue) => {
                            setRating(newValue);
                          }}
                          onChangeActive={(event, newHover) => {
                            setHover(newHover);
                          }}
                        />

                        {rating !== null &&
                          labels[hover !== -1 ? hover : rating]}
                      </div>
                    </div>

                    <TextField
                      fullWidth
                      label="Review"
                      minRows={3}
                      multiline
                      inputProps={{ readOnly: isSubmitted || formID }}
                      value={review}
                      onChange={(e) => setReview(e.target.value)}
                    />
                  </div>
                )}

                {formID && (
                  <IconButton
                    className="close-button"
                    onClick={() => onClose()}
                  >
                    <CloseOutlined />
                  </IconButton>
                )}
              </div>

              <section className="buttons">
                {!formID && !isLoading && !isSubmitted && (
                  <button
                    className="confirm"
                    disabled={isSubmitting || isLoading || isSubmitted}
                    type="submit"
                  >
                    {isSubmitting && <CircularProgress className="progress" />}
                    Submit
                  </button>
                )}
              </section>
            </form>
          </div>
        </Dialog>
      </div>
    </div>
  );
};

export default CustomerRating;
